import React from 'react';
import { Empty } from 'antd';

export default function NotFoundView() {
    return (
        <div style={{width: '100%', height: '100%'}} className="flex center middle">
            <Empty description="404 NotFound"/>
        </div>
    )
}